import { createAction } from 'redux-actions'

export const setQuestionnaire = createAction('SET_QUESTIONNAIRE')
